import React from 'react';
import { prop } from 'ramda';
import { useAppSelector } from 'js/store/hooks';

import { Tag } from './components/Tag';

export const Tags = () => {
    const tags = useAppSelector(prop('tags'));

    return tags.map(tag => (
        <Tag
            key={tag.tagId}
            tag={tag}
        />
    ));
};
